import {FiGlobe, FiLock, FiUsers} from "react-icons/fi";

import {Icon} from "@/components/icon/Icon.tsx";
import {StatusPageDisplay, StatusPageVisibilityLevel} from "@/lib/types/statuspages.ts";

export interface StatusPageVisibilityCellProps {
  visibilityLevel: StatusPageVisibilityLevel;
}

const Icons = {
  [StatusPageVisibilityLevel.PUBLIC]: FiGlobe,
  [StatusPageVisibilityLevel.UPTIME_USERS]: FiUsers,
  [StatusPageVisibilityLevel.EXTERNAL_USERS]: FiLock,
};

export const StatusPageVisibilityCell = ({visibilityLevel}: StatusPageVisibilityCellProps) => {
  const displayName = StatusPageDisplay[visibilityLevel];
  const icon = Icons[visibilityLevel];
  return (
    <span className="pulseTextBodySmall pulse-color-gray-900 text-nowrap">
      <Icon icon={icon} display={"inline"} />
      {displayName}
    </span>
  );
};
